import React, { ChangeEvent, useEffect, useState } from "react";
import { GVP, GVPForm, UserData, UserProfile } from "../models/types";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import {
  deleteGVPLine,
  getGVP,
  getGVPStatus,
  setGVPEdit,
  updateGVP,
  updateGVPLater,
} from "../store/users/action";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { ApplicationState } from "../store";
import { FormattedMessage, useIntl } from "react-intl";
import InputTextField from "./TextField";
import ProfileDocumentViewer from "./ProfileDocumentViewer";
import InfoIcon from "@material-ui/icons/Info";
import ProfileSignDocument from "./ProfileSignDocument";
import { sendSign } from "../store/sign/action";
import { theme } from "../theme/retrostyle";
import InputSelectField from "./SelectField";
import { getDay, set, setDate } from "date-fns";
import DatePicker, { registerLocale } from "react-datepicker";
import "./styles/datepicker.css";
import moment from "moment";
import lv from "date-fns/locale/lv";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";


const isWeekday = (date: Date) => {
  const day: number = getDay(date);
  return day !== 0;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      flexBasis: "100%",
      flexShrink: 0,
      fontSize: "14px",
      fontWeight: "bold",
      color: "#333333",
    },
    red: {
      color: "#EC574E",
      fontSize: "30px",
      "&:hover": {
        cursor: "pointer",
        color: "#da2232",
      },
    },
    titleBig: {
      marginBottom: 2,
      fontWeight: 600,
      padding: "2rem",
      color: "#333333",
      textAlign: "center",
    },
    infoText: {
      fontWeight: 400,
      lineHeight: 2,
      paddingBottom: "2rem",
      color: "#333333",
      textAlign: "center",
    },
    tableHeader: {
      borderBottom: "1px solid #E3E3E3",
      padding: "0px",
    },
    tableTitle: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "10px",
      lineHeight: "16px",
      letterSpacing: "1.5px",
      textTransform: "uppercase",
      color: "#858585",
    },
    tableText: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "14px",
      lineHeight: "16px",
      letterSpacing: "1.5px",
      textTransform: "uppercase",
      color: "#333333",
    },
    statusGreen: {
      background: "#D7EC84",
      fontSize: "12px",
      padding: "6px",
    },
    statusRed: {
      background: "#EC574E",
      fontSize: "12px",
      padding: "6px",
      color: "#ffffff",
    },
    statusGrey: {
      backgroundColor: "#E3E3E3 !important",
      fontSize: "12px",
      padding: "6px",
    },
    button: {
      width: "300px",
      backgroundColor: "#da2232",
      margin: "10px",
      color: "#ffffff",
      borderRadius: "0px",
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#9b1b25",
        color: "#ffffff",
      },
    },
    buttonInfo: {
      width: "37px",
      backgroundColor: "#ffffff",
      margin: "10px",
      color: "#333333",
      borderRadius: "0px",
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#ffffff",
        color: "#333333",
      },
    },
    menuButtonDark: {
      width: "300px",
      backgroundColor: "#333333",
      color: "#ffffff",
      border: "0px",
      margin: "10px",
      borderRadius: "0px",
      textDecoration: "none",
      textAlign: "center",
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#333333",
        color: "#ffffff",
      },
    },
    checkbox: {
      color: "#333333",
    },
    back: {
      fontSize: "15px",
      fontWeight: "bold",
      color: "#666666",
      paddingBottom: "16px",
      textDecoration: "underline",
      "&:hover": {
        cursor: "pointer",
        color: "#000000",
      },
    },
    backIcon: {
      fontSize: "15px",
      fontWeight: "bold",
      color: "#666666",
      paddingBottom: "16px",
      "&:hover": {
        cursor: "pointer",
        color: "#000000",
      },
    },
    title: {
      marginBottom: 2,
      height: "29px",
      fontSize: "14px",
      letterSpacing: "0.25px",
      color: "#333333",
      textAlign: "left",
    },
    hr: {
      border: "none",
      height: "1px",
      color: "#e3e3e3",
      backgroundColor: "#e3e3e3",
    },
    gContainer: {
      minHeight: "70vh",
    },
    inputInput: {
      transition: theme.transitions.create("width"),
      paddingLeft: `calc(0.1em + ${theme.spacing(1)}px)`,
      width: "100px",
      borders: "0px",
      background: "#ffffff",
      borderTop: "0px",
      borderRight: "0px",
      borderLeft: "0px",
      fontSize: "16px",
      color: "#333333",
      borderBottomColor: "#333333",
    },
  })
);

interface propsFromDispatch {
  getGVP: () => any;
  getGVPStatus: () => any;
  setGVPEdit: () => any;
  updateGVP: (payload: any) => any;
  updateGVPLater: (payload: any) => any;
  deleteGVPLine: (payload: any) => any;
}
interface PropsFromState {
  gvp?: GVP;
  gvpLoading: boolean;
  login: boolean;
  profile: UserProfile;
  user: UserData;
}

interface IProps {
  setNewGVP: (value: number) => any;
}

type AllProps = PropsFromState & propsFromDispatch & IProps;

const ProfileGVP: React.FC<AllProps> = ({
  gvp,
  gvpLoading,
  login,
  profile,
  user,
  getGVP,
  setGVPEdit,
  getGVPStatus,
  updateGVP,
  deleteGVPLine,
  setNewGVP,
  updateGVPLater,
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [loop, setLoop] = useState(0);
  const [expiryDate, setExpiryDate] = useState<Date>();
  const [formError, setFormErrors] = useState<any>({});
  const [formState, setFormState] = useState<GVP>({});
  const [isDocumentOpen, setIsDocument] = useState(false);
  const [signDocument, setSignDocument] = useState(false);
  const [hash, setHash] = useState("");
  const signReasons: any = [
    {code: "valdes loceklis", value: {"lv": "valdes loceklis"}},
    {code: "valdes priekšsēdētājs", value: {"lv": "valdes priekšsēdētājs"}},
    {code: "prokūrists", value: {"lv": "prokūrists"}},
    {code: "īpašnieks", value: {"lv": "īpašnieks"}},
    {code: "savs variants", value: {"lv": "savs variants"}}
  ];

  const signRole: any = [
    {code: "statūtu", value: {"lv": "statūtu"}},
    {code: "pilnvarojuma", value: {"lv": "pilnvarojuma"}},
    {code: "īpašumtiesības", value: {"lv": "īpašumtiesības"}},
    {code: "prokūras", value: {"lv": "prokūras"}},
    {code: "pārstāvības", value: {"lv": "pārstāvības"}},
    {code: "nolikuma", value: {"lv": "nolikuma"}},
    {code: "rīkojuma", value: {"lv": "rīkojuma"}},
  ];

  useEffect(() => {
    getGVP();
  }, []);

  useEffect(() => {
    if (gvp) {
      setFormState({});
      setFormState(gvp);
      if (gvp?.endDate) setExpiryDate(moment(gvp?.endDate, "DD.MM.YYYY").toDate())
    }
  }, [gvp]);

  useEffect(() => {
    setFormState({
      ...formState,
      endDate: moment(expiryDate).format("DD.MM.YYYY"),
    });
  }, [expiryDate]);

  useEffect(() => {
    if (gvp?.status === "REPORT" && login) {
      setLoop(
        window.setInterval(() => {
          getGVPStatus();
        }, 5000)
      );
    } else {
      clearInterval(loop);
    }
  }, [gvp?.status, login]);

  const handleSelectChange = (e: any) => {
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    const { checked, name, value, type } = e.currentTarget;
    const setValue = type === "checkbox" ? checked === true ? 1 : 0 : value;
    setFormState({
      ...formState,
      [name]: setValue,
    });
  };

  const handleFormChange = (
    e: ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const { checked, name, value, type } = e.currentTarget;
    const setValue = type === "checkbox" ? checked === true ? 1 : 0 : value;
    if (formState.form) {
      const newForm: GVPForm[] = formState.form.map((row, rindex) => {
        if (rindex === index) {
          return {
            ...row,
            [name]: setValue,
          };
        } else {
          return row;
        }
      });

      setFormState({
        ...formState,
        form: newForm,
      });
    }
  };

  const addRow = () => {
    let gvp: GVPForm = {
      id: 0,
      ssn: "",
      name: "",
      role: "",
      surname: "",
      phone: "",
      email: "",
      sign: false,
      receive: false,
      payment: false,
    };

    let employees = formState;
    employees.form?.push(gvp);
    setFormState({ ...formState, form: employees.form });
  };

  const saveForm = () => {
    updateGVP(formState);
  };

  const saveFormExit = () => {
    updateGVPLater(formState);
    setNewGVP(0);
  };

  const editForm = () => {
    setGVPEdit();
  };

  const signForm = () => {
      window.alert("99999999999999999999")
    setSignDocument((current) => !current);
  };

  const signDocumentOpen = async (documentId: string) => {
      window.alert("1212121212121212")
    let data: any = await sendSign(documentId);
    if (data?.status === "REQUESTED") {
      setHash(data?.hash);
      setSignDocument((current) => !current);
    }
  };

  const popupHandler = () => {
    setIsDocument((current) => !current);
  };

  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  return !mobile ? (
    <Box className={classes.gContainer}>
      {!gvpLoading ? (
        <>
          <ProfileDocumentViewer
            fileName={formState.fileName}
            isDocumentOpen={isDocumentOpen}
            closeHandler={popupHandler}
          />
        </>
      ) : null}
      <ProfileSignDocument
        isSignOpen={signDocument}
        hash={hash}
        closeHandler={signForm}
      />
      <Grid container spacing={2}>
        <Grid item sm={12}>
          <Typography className={classes.titleBig}>
            {gvp?.status === "NEW"
              ? "Lai saņemtu nomas pakalpojumu, jums ir jāaizpilda garantijas vēstule – pilnvara (GVP)"
              : null}

            {gvp?.status === "REPORT"
              ? "Garantijas vēstule – pilnvara tiek gatavota."
              : null}

            {gvp?.status === "SIGN"
              ? "Garantijas vēstule – pilnvara, ir sagatavota. Parakstiet izmantojot SmartId."
              : null}

            <IconButton
              className={classes.buttonInfo}
              aria-label="Info"
              aria-haspopup="true"
              onClick={popupHandler}
              color="inherit"
            >
              <InfoIcon />
            </IconButton>
          </Typography>
                <Typography className={classes.infoText}>
                  Ņemiet vērā, kā tikai paraksttiesīgajām personām ir tiesības pilnvarot darbiniekus! Obligāti pievienojiet sevi, <b>JA ESAT PARAKSTIEĪGA PERSONA</b>, un, ja ir nepieciešamība, pievienojiet arī citus darbiniekus.
                </Typography>
                <Typography className={classes.infoText}>
                  Ar šo {profile.contractCode}, turpmāk tekstā - Uzņēmums, tā &nbsp;
                  { gvp?.status === "NEW" ?
                    <>
                      <Box style={{ width: "150px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                        <InputSelectField
                          name="signReason"
                          title={"Amats"}
                          enabled={gvp?.status === "NEW" ? true : false}
                          list={signReasons}
                          value={formState.signReason || ""}
                          error={formError.signReason}
                          formChange={handleSelectChange}
                        />
                      </Box> 
                      {formState.signReason === "savs variants" ? 
                      <Box style={{ width: "150px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                        <InputTextField
                          name="signReasonCustom"
                          required={true}
                          title="Amats"
                          value={(formState?.signReasonCustom || "").toUpperCase()}
                          error={formError.signReasonCustom}
                          enabled={gvp?.status === "NEW" ? true : false}
                          formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                            handleInputChange(ev)
                          }
                        />
                      </Box> 
                      : null}
                     </>
                  : formState.signReason === "savs variants" ? formState.signReasonCustom : formState.signReason } &nbsp;
                  {gvp?.status === "NEW" ? 
                  <Box style={{ width: "250px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                    <InputTextField
                      name="signName"
                      required={true}
                      title="Vārds, Uzvārds"
                      value={(formState?.signName || "").toUpperCase()}
                      error={formError.signName}
                      enabled={gvp?.status === "NEW" ? true : false}
                      formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                        handleInputChange(ev)
                      }
                    />
                  </Box>
                  : formState.signName }
                  , 
                </Typography>
                <Typography className={classes.infoText}>
                  kurš(a) rīkojas uz &nbsp;
                  { gvp?.status === "NEW" ?
                    <Box style={{ width: "150px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                    <InputSelectField 
                      name="signRole"
                      title={"Pamats"}
                      enabled={gvp?.status === "NEW" ? true : false}
                      list={signRole}
                      value={formState.signRole || ""}
                      error={formError.signRole}
                      formChange={handleSelectChange}
                    /> 
                    </Box>
                    : formState.signRole } &nbsp;
                  pamata, <b>garantē un apstiprina līdz</b>&nbsp;
                  { gvp?.status === "NEW" ?
                    <Box style={{ width: "110px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                      <DatePicker
                        selected={expiryDate}
                        onChange={(date: Date) => setExpiryDate(date)}
                        selectsEnd
                        monthsShown={2}
                        locale={lv}
                        startDate={expiryDate}
                        minDate={moment().toDate()}
                        filterDate={isWeekday}
                        dateFormat="dd.MM.yyyy"
                        placeholderText={"Līdz"}
                        className={classes.inputInput}
                      />
                    </Box>
                    : formState.endDate 
                  } &nbsp;
                  sekojošus darbiniekus un, ja 
                </Typography>
                <Typography className={classes.infoText}>
                Uzņēmuma pārstāvis personīgi nav ieradies pēc rēķina 3 dienu laikā no tā izrakstīšanas brīža, tad apliecina, rēķins ir jānosūta: 
                </Typography>
                <Typography className={classes.infoText}>
                  <Box style={{ textAlign: "left"}} >
                  <Box style={{ width: "30px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                    <Checkbox
                      onChange={handleInputChange}
                      name="sendPost"
                      id="sendPost"
                      disabled={gvp?.status === "NEW" ? false : true}
                      checked={formState.sendPost === 1 ? true : false}
                      className={classes.checkbox}
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </Box>
                  pa pastu uz Uzņēmuma adresi (par atsevišķu maksu): &nbsp;
                  {gvp?.status === "NEW" ? 
                    <Box style={{ width: "450px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                      <InputTextField
                        name="sendPostAddress"
                        required={true}
                        title="Adrese"
                        value={(formState?.sendPostAddress || "").toUpperCase() || (profile.registrationAddress || "").toUpperCase()}
                        error={formError?.sendPostAddress}
                        enabled={gvp?.status === "NEW" ? true : false}
                        formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                          handleInputChange(ev)
                        }
                      />
                    </Box>
                  : formState?.sendPostAddress }
                  <br/>
                  <Box style={{ width: "30px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                    <Checkbox
                      onChange={handleInputChange}
                      name="sendEmail"
                      id="sendEmail"
                      disabled={gvp?.status === "NEW" ? false : true}
                      checked={formState?.sendEmail === 1 ? true : false}
                      className={classes.checkbox}
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </Box>
                  uz Uzņēmuma e-pasta adresi (bez maksas): &nbsp;
                  {gvp?.status === "NEW" ? 
                  <Box style={{ width: "450px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                    <InputTextField
                      name="sendEmailAddress"
                      required={true}
                      title="E-pasta adrese"
                      value={(formState?.sendEmailAddress || "").toUpperCase() || (user.profile.email || "").toUpperCase()}
                      error={formError?.sendEmailAddress}
                      enabled={gvp?.status === "NEW" ? true : false}
                      formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                        handleInputChange(ev)
                      }
                    />
                  </Box>
                  : formState?.sendEmailAddress }
                  <br/>
                  <Box style={{ width: "30px", paddingLeft: "5px", paddingRight: "5px" }} display="inline-block">
                    <Checkbox
                      onChange={handleInputChange}
                      name="marketing"
                      id="marketing"
                      disabled={gvp?.status === "NEW" ? false : true}
                      checked={formState?.marketing === 1 ? true : false}
                      className={classes.checkbox}
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </Box>
                  Apliecinu, ka Uzņēmums vēlas saņemt informatīvos sūtījumus no SIA STATS RENT par īpašiem piedāvājumiem uz rekvizītos augstāk minēto e-pasta adresi.
                  </Box>
                </Typography>
        </Grid>
        <Grid item sm={12} spacing={2}>
          <Grid container className={classes.tableHeader} spacing={2}>
            <Grid item md={2}>
              <Typography className={classes.tableTitle}>
                Vārds
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography className={classes.tableTitle}>
                Uzvārds
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography className={classes.tableTitle}>
                Personas kods
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography className={classes.tableTitle}>
                E-pasts
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography className={classes.tableTitle}>
                Telefons
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Typography className={classes.tableTitle}>
                Darbības
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={12}>
          <Grid container spacing={2}>
            {!gvpLoading
              ? formState.form?.map((employee, index) => (
                  <>
                    <Grid item md={2}>
                      <InputTextField
                        name="name"
                        required={true}
                        value={(employee?.name || "").toUpperCase()}
                        error={formError.name}
                        enabled={gvp?.status === "NEW" ? true : false}
                        formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                          handleFormChange(ev, index)
                        }
                      />
                    </Grid>
                    <Grid item md={2}>
                      <InputTextField
                        name="surname"
                        required={true}
                        value={(employee?.surname || "").toUpperCase()}
                        error={formError.surname}
                        enabled={gvp?.status === "NEW" ? true : false}
                        formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                          handleFormChange(ev, index)
                        }
                      />
                    </Grid>
                    <Grid item md={2}>
                      <InputTextField
                        name="ssn"
                        required={true}
                        value={employee?.ssn}
                        error={formError.ssn}
                        enabled={gvp?.status === "NEW" ? true : false}
                        formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                          handleFormChange(ev, index)
                        }
                      />
                    </Grid>
                    <Grid item md={2}>
                      <InputTextField
                        name="email"
                        value={(employee?.email || "").toUpperCase()}
                        error={formError.email}
                        enabled={gvp?.status === "NEW" ? true : false}
                        formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                          handleFormChange(ev, index)
                        }
                      />
                    </Grid>
                    <Grid item md={2}>
                      <InputTextField
                        name="phone"
                        required={true}
                        value={employee?.phone}
                        error={formError.phone}
                        enabled={gvp?.status === "NEW" ? true : false}
                        formChange={(ev: ChangeEvent<HTMLInputElement>): void =>
                          handleFormChange(ev, index)
                        }
                      />
                    </Grid>
                    <Grid item md={2}>
                      {gvp?.status === "NEW" ?
                       <Box
                          textAlign="center"
                          onClick={() => deleteGVPLine(employee?.id)}
                        >
                          <DeleteForeverIcon className={classes.red} />
                        </Box>
                       : false}
                    </Grid>     
                  </>
                ))
              : null}
            <Grid item md={12}>
              <Box textAlign="right" pb={3}>
                {gvp?.status === "NEW" ? (
                  <>
                    <Button
                      variant="contained"
                      onClick={() => addRow()}
                      size="large"
                      className={classes.menuButtonDark}
                    >
                      <FormattedMessage id="profile.gvpAdd" />
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => saveForm()}
                      size="large"
                      className={classes.button}
                    >
                      <FormattedMessage id="save" />
                    </Button>
                  </>
                ) : null}

                {gvp?.status === "REPORT" || gvp?.status === "SIGN" ? (
                  <Button
                    variant="contained"
                    onClick={() => editForm()}
                    size="large"
                    className={classes.button}
                  >
                    <FormattedMessage id="profile.gvpEdit" />
                  </Button>
                ) : null}

                {gvp?.status === "SIGN" ? (
                  <Button
                    variant="contained"
                    onClick={() => signDocumentOpen(gvp?.id.toString())}
                    size="large"
                    className={classes.button}
                  >
                    <FormattedMessage id="profile.gvpSign" />
                  </Button>
                ) : null}
                <Button
                  variant="contained"
                  onClick={() => saveFormExit()}
                  size="large"
                  className={classes.menuButtonDark}
                >
                  Parakstīt vēlāk
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <Box textAlign="center">
      Sadarbības līgumu var aizpildīt tikai izmantojot pārlūku datorā!
    </Box>
  );
};

const mapStateToProps = ({ user }: ApplicationState) => ({
  gvp: user.profile.gvp,
  gvpLoading: user.gvpLoading,
  login: user.login,
  profile: user.profile,
  user: user.user,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    getGVP: () => {
      dispatch(getGVP());
    },
    getGVPStatus: () => {
      dispatch(getGVPStatus());
    },
    setGVPEdit: () => {
      dispatch(setGVPEdit());
    },
    updateGVP: (payload: any) => {
      dispatch(updateGVP(payload));
    },
    updateGVPLater: (payload: any) => {
      dispatch(updateGVPLater(payload));
    },
    deleteGVPLine: (clientAgreementFormEntryId: number) => {
      dispatch(deleteGVPLine(clientAgreementFormEntryId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileGVP);
